import React from 'react'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers/AssetHelpers'
import { useIntl } from 'react-intl'

export const InfoCard = ({ title, desc, slug }: { title: string, desc: string, slug: string }) => {
  const { formatMessage } = useIntl()
  return (
    <div className='info-card important-notice-card'>
      <div className='card mt-0 fs-6 flex-row mb-md-4 mb-8 '>
        <div className='me-4'>
          <img src={toAbsoluteUrl('/media/icons/duotune/general/file_image.svg')} alt='' />
        </div>
        <div>
          <div className=' fw-bold mb-1'>{title}</div>
          <div className='fw-normal' style={{ fontSize: '13px !important', fontWeight: '500', lineHeight: '20px', textAlign: 'left' }}>{desc}</div>

          <div className='d-flex justify-content-end'>
            <a href={slug} className='ms-1 link-primary' target='_blank' rel='noopener noreferrer'>
              {formatMessage({ id: 'Learn More' })}{' '}
              <span className='ms-5'>
                <img src={toAbsoluteUrl('/media/icons/duotune/general/arrow-right.svg')} alt='' />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
